import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

// servicios
import { UsuarioService } from './datos/usuario.service';
import { CronTotalesMenuService } from './cron-totales-menu.service';

// Librerías, entorno
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  $obserbable = new Observable;
  menu: any[] = [];

  private menuState = new BehaviorSubject<string | null>(null);
  menuState$ = this.menuState.asObservable();


  constructor(
    private usuarioSrv: UsuarioService,
    public cronTotalesSrv: CronTotalesMenuService
  ) {
  }

  cargarMenu() {
    this.menu = [];
    const rol = this.usuarioSrv.userdata.rol || 'usuario';

    // Que puede ver en función de su rol:
    const verMaestros = ['jefeAlmacen', 'admin', 'sa'];
    const verTablas = ['jefeAlmacen', 'admin', 'sa'];
    const verClientes = ['cliente', 'admin', 'sa'];
    const verGestion = ['jefeAlmacen', 'admin', 'sa'];
    const verAdministracion = environment.rolesAdministracion;
    const verSistema = ['sa'];

    // Menú global 
    this.menu.push({
      id: 'panel',
      titulo: 'Panel',
      icono: 'fa-solid fa-gauge',
      submenu: [
        { titulo: 'Estado', url: '/panel/estado' },
      ]
    });

    // Clientes
    this.menu.push({
      id: 'clientes',
      titulo: 'Clientes',
      icono: 'fa-solid fa-user-group',
      submenu: [
        { titulo: 'Clientes', url: 'clientes_lista' },
        { titulo: 'Nuevo Cliente', url: 'cliente_edit/new' },
        { titulo: 'Facturar', url: 'cliente_facturar' },
        { titulo: 'Historico Facturación', url: 'cliente_fac_list' },
        { titulo: 'Notificaciones', url: 'cliente_msg_list' },
      ]
    });

    // Articulos
    this.menu.push({
      id: 'articulos',
      titulo: 'Articulos',
      icono: 'fa-solid fa-shapes',
      submenu: [
        { titulo: 'Artículos', url: 'articulos_lista' },
        { titulo: 'Nuevo Artículo', url: 'articulo_edit/new' }
      ]
    });

    // Stock
    this.menu.push({
      id: 'stock',
      titulo: 'Stock',
      icono: 'fa-solid fa-layer-group',
      submenu: [
        { titulo: 'Stock', url: 'stock_lista' },
        { titulo: 'Stock Histórico', url: 'stock_lista_historico' },
        { titulo: 'Transacciones', url: 'transacciones' },
      ]
    });

    // Entradas
    this.menu.push({
      id: 'entradas',
      titulo: 'Entradas',
      icono: 'fa fa-truck',
      submenu: [
        { titulo: 'Pendientes', url: 'entradas_lista' },
        { titulo: 'Nueva Entrada', url: 'entrada_edit/new' },
        { titulo: 'No Confirmadas', url: 'entradas_ubicadas_lista/1' },
        { titulo: 'Finalizadas PDA', url: 'entradas_ubicadas_lista/2' },
      ]
    });

    // Pedidos
    this.menu.push({
      id: 'pedidos',
      titulo: 'Pedidos',
      icono: 'fa-solid fa-receipt',
      submenu: [
        { titulo: 'Campañas', url: 'campanyas_lista' },
        { titulo: 'Cargar Campaña', url: 'campanya_new' },
        { titulo: 'Consulta de pedidos', url: 'pedidos_lista' },
        { titulo: 'Trazabilidad de Lotes', url: 'traza_lista' },
        { titulo: 'Incidencias en recogidas', url: 'preparaciones_incidencias_list' },
        { titulo: 'Etiquetas UIC', url: 'uic-labels' },
        { titulo: 'Info UIC', url: 'uic-info' },
      ]
    });

    // Preparaciones
    // this.menu.push({
    //   id: 'preparaciones',
    //   titulo: 'Preparaciones',
    //   icono: 'fa-solid fa-clipboard-list',
    //   submenu: [
    //     { titulo: 'Preparación de oleada', url: '' },
    //     { titulo: 'Pedidos simultáneamente a recogida', url: '' },
    //     { titulo: 'Cross Docking', url: '' },
    //   ]
    // });

    // Ubicaciones
    if (verTablas.includes(rol)) {
      this.menu.push({
        id: 'ubicaciones',
        titulo: 'Ubicaciones',
        icono: 'fa-solid fa-table-list',
        submenu: [
          { titulo: 'Almacenes', url: 'almacenes' },
          { titulo: 'Ubicaciones', url: 'ubicaciones' },
          { titulo: 'Nueva Ubicación', url: 'ubicacion/new' },
          { titulo: 'Etiquetas Ubicaciones', url: 'ubicaciones_labels' },
          { titulo: 'Tipos de ubicación', url: 'ubi_tipos' },
        ]
      });
    }

    // opciones de Administración 
    if (verAdministracion.includes(rol)) {
      const submenu = [
        { titulo: 'Usuarios', url: 'usr_lista' },
        { titulo: 'Nuevo Usuario', url: 'usuario/new' },
      ];
      if (verSistema.includes(rol)) {
        submenu.push({ titulo: 'Info server', url: 'info' });
      }
      this.menu.push({
        id: 'administracion',
        titulo: 'Administración',
        icono: 'fa-solid fa-cogs',
        submenu: submenu
      });
    }
  }

  /**
   * Obtener el número de notificaciones para un item del menú
   * @param url URL del item del menú
   * @returns número de notificaciones
   */
  getNotificaciones(url: string): number {
    switch (url) {
      case 'campanya_new':
        return this.cronTotalesSrv.totales?.pedidosSinCamp || 0;
      case 'entradas_lista':
        return this.cronTotalesSrv.totales?.entradasPendientes || 0;
      default:
        return 0;
    }
  }

  /** Fuerza abrir un menú pasando su identificador (ej: 'perfil', 'entradas', etc.) */
  expandMenu(menuId: string) {
    console.log('__sidebarSrv.expandMenu menuId:', menuId);
    this.menuState.next(menuId);
  }


}